<template>
  <div class="page">
    <div class="bg-content padding15">
      <el-tabs v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane label="策略交互" name="策略交互">
          <conversational-information></conversational-information>
        </el-tab-pane>
        <el-tab-pane label="场景交互" name="场景交互">
          <scene-info></scene-info>
        </el-tab-pane>
        <el-tab-pane label="作业设置" name="作业设置">
          <collection-set></collection-set>
        </el-tab-pane>
        <el-tab-pane label="作业信息" name="作业信息">
          <collection-information></collection-information>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import conversationalInformation from './conversational_information';
import collectionSet from './collection_set';
import collectionInformation from './collection_information';
import sceneInfo from './scene_info';

export default {
  data() {
    return {
      activeTab: '策略交互'
    };
  },
  methods: {
    handleClick() {}
  },
  components: {
    conversationalInformation, collectionSet, collectionInformation, sceneInfo
  }
};
</script>




// WEBPACK FOOTER //
// src/page/main/test_engine/index.vue